import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { UTMICampaign as UTMType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type UTMProps = {
  utmiCampaign: UTMType | undefined
}
export function UTMICampaign(props: UTMProps) {
  const { formatList } = useIntl()
  const { utmiCampaign } = props

  const noUtmSet = !utmiCampaign || !utmiCampaign.utmiCampaign.length

  if (noUtmSet) return null

  const processTooltip = () =>
    formatList(utmiCampaign.utmiCampaign, { type: 'disjunction' })

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.utmiCampaign.title} />
      </Tag>
    </Tooltip>
  )
}
